// services/order-encoder.service.ts
import { Injectable } from '@angular/core';
import { BaseclientService } from './apiclient/baseclient.service';

interface SuccessOrderEncodeResponse {
    success: boolean;
    hash: string;      // ici hash = token complet (HASH ou HASH.UBER)
    orderId: number;
}

interface SuccessOrderDecodeResponse {
    success: boolean;
    orderId: number;
    uberTrackingUrl?: string | null;
}


@Injectable({
    providedIn: 'root'
})
export class OrderEncoderService {

    constructor(
        private baseClient: BaseclientService,
    ) { }

    /**
     * Encode un order ID
     */
    async encodeOrderId(orderId: number, uberTrackingUrl?: string): Promise<SuccessOrderEncodeResponse> {
        return this.baseClient.postBase(`encodeSuccessOrderId`, {
            orderId,
            uberTrackingUrl,
        });
    }

    /**
     * Decode un hash
     */
    async decryptOrderId(encryptedId: string): Promise<SuccessOrderDecodeResponse> {
        try {
            // console.log("success-order-encoder.service - decryptOrderId - encryptedId : ", encryptedId);
            const params = { hash: encryptedId };
            // console.log("success-order-encoder.service - decryptOrderId - params : ", params);
            const result = await this.baseClient.getBase("decodeSuccessOrderId", params);
            // console.log("success-order-encoder.service - decryptOrderId - result : ", result);

            // Supporte plusieurs formats (selon ton API actuelle)
            const payload = result?.data ?? result;

            const orderId = payload?.orderId ?? payload?.data?.orderId;
            if (!orderId) {
                throw new Error("Format de réponse invalide (orderId manquant)");
            }

            const uberTrackingUrl =
                payload?.uberTrackingUrl ??
                payload?.data?.uberTrackingUrl ??
                null;

            return {
                success: payload?.success ?? true,
                orderId: Number(orderId),
                uberTrackingUrl,
            };
        } catch (error) {
            console.error("Erreur décryptage:", error);
            throw new Error("Impossible de décoder l'ID de commande");
        }
    }
}
